module.exports = __webpack_public_path__ + "static/media/content-sent@2x.5197d25d.png";